export default function Loading(){
    return(
        <div className="spinner-container-submit">
            <div className="spinner"></div>
        </div>
    )
}